export var Type;
(function (Type) {
    Type["INFO"] = "info";
    Type["SUCCESS"] = "success";
    Type["WARNING"] = "warning";
    Type["ERROR"] = "error";
})(Type || (Type = {}));
export var Default;
(function (Default) {
    Default[Default["COLLAPSE_DURATION"] = 300] = "COLLAPSE_DURATION";
    Default[Default["DEBOUNCE_DURATION"] = 50] = "DEBOUNCE_DURATION";
    Default["CSS_NAMESPACE"] = "Stardust";
    Default[Default["DRAGGABLE_PERCENT"] = 20] = "DRAGGABLE_PERCENT";
    Default["IS_OUT_BG"] = "transparent";
})(Default || (Default = {}));
export var Direction;
(function (Direction) {
    Direction["X"] = "x";
    Direction["Y"] = "y";
})(Direction || (Direction = {}));
export var SyntheticEvent;
(function (SyntheticEvent) {
    SyntheticEvent["ENTRANCE_ANIMATION_END"] = "d";
})(SyntheticEvent || (SyntheticEvent = {}));
export var EventActions;
(function (EventActions) {
    EventActions[EventActions["Show"] = 0] = "Show";
    EventActions[EventActions["Clear"] = 1] = "Clear";
    EventActions[EventActions["DidMount"] = 2] = "DidMount";
    EventActions[EventActions["WillUnmount"] = 3] = "WillUnmount";
    EventActions[EventActions["Change"] = 4] = "Change";
})(EventActions || (EventActions = {}));
